import { fetcher } from "@utils/common"
import useSWR from "swr"

const usePopular = () => {
  const { data: popularProducts, isLoading: popularProductsLoading } = useSWR(
    "/api/products/popular",
    fetcher,
    {
      revalidateOnFocus: false,
    }
  )

  return {
    popularProducts,
    popularProductsLoading,
  }
}

export default usePopular
